import React, { Component } from 'react';
import { useHistory } from 'react-router';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem } from 'reactstrap';
import './NavMenu.css';
import AuthService from "../services/AuthService";

function UnauthenticatedNavMenu(props) {
    return (
        <ul className="navbar-nav flex-grow">
            <NavItem>
                <a className="text-dark nav-link" href={props.registerUrl}>Register</a>
            </NavItem>
            <NavItem>
                <span className="text-dark nav-link" onClick={props.onLoginClick}>Login</span>
            </NavItem>
        </ul>
    );
}

function AuthenticatedNavMenu(props) {
    const history = useHistory();
    return (
        <ul className="navbar-nav flex-grow">
            <NavItem>
                <span className="text-dark nav-link" onClick={ () => { props.toggleNavbar(); history.push('/Shipments');}}>My Jobs - All</span>
            </NavItem>
            <NavItem>
                <span className="text-dark nav-link" onClick={ () => { props.toggleNavbar(); history.push('/Preferences');}}>Preferences</span>
            </NavItem>
            <NavItem>
                <span className="text-dark nav-link" onClick={props.onLogoutClick}>Logout</span>
            </NavItem>
        </ul>
    );
}


export class NavMenu extends Component {
    static displayName = NavMenu.name;    

    constructor(props) {
        super(props);

        this.state = {
            collapsed: true,
            hideLogin: false,
            registerUrl: "/identity/Account/Register",
            manageUrl: "/identity/Manage"
        };  
        this.i = 0;
    }

    async componentDidMount() {
        this.authService = await AuthService.getInstance();
        var authorityUrl = this.authService.getAuthUrl();
        var redirectUrl = this.authService.getRedirectUrl();        

        this.setState({
            registerUrl: `${authorityUrl}/Account/Register?returnUrl=${redirectUrl}?new=true`,
            manageUrl: `${authorityUrl}/Manage`,
            preferenceUrl: `/Preferences`
        });

        await this.checkLoginState();
    }

    checkLoginState = async () => {        
        var user = await this.authService.getUser();
        console.log('checking login state', this.i, user == null);
        if(this.i++ < 20){
            setTimeout(this.checkLoginState, this.i * 80 + 1);            
        }
        this.setState({
            hideLogin: user !== null,
        });
    }

    toggleNavbar = () => {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    login = async () => {
        console.log('sign in redirect', this.authService);
        await this.authService.signinRedirect();
    }

    logout = async () => {
        await this.authService.logout();
    }

    render() {        
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white" light>
                    <Container>
                        {<NavbarToggler onClick={this.toggleNavbar} className="mr-2" />}
                        <NavbarToggler style={{visibility: "hidden"}} className="mr-2" />
                        <NavbarBrand>
                            <img alt="" src="images/footer-logo.gif"></img>
                            {this.props.busy && <div className="lds-dual-ring global"></div>}
                        </NavbarBrand>
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                            {
                                !this.state.hideLogin &&
                                <UnauthenticatedNavMenu
                                    registerUrl={this.state.registerUrl}
                                    onLoginClick={this.login}
                                    />
                            }
                            {
                                this.state.hideLogin && 
                                <AuthenticatedNavMenu
                                    toggleNavbar={this.toggleNavbar}
                                    onLogoutClick={this.logout}
                                    />
                            }
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}
